import { API_URL } from '../../../config.js';
import { toApiError } from '../../../lib/api-error.js';

type FeatureFlag = {
  id: string;
  name: string;
  description: string | null;
  enabled: boolean;
};

type FeatureFlagsResponse = { flags: FeatureFlag[] };

export type FetchFeatureFlagsFn = (input: string, init?: RequestInit) => Promise<Response>;

type FetchFeatureFlagsOptions = {
  apiUrl?: string;
  fetchFn?: FetchFeatureFlagsFn;
};

export async function fetchFeatureFlags({
  apiUrl = API_URL,
  fetchFn = fetch,
}: FetchFeatureFlagsOptions = {}): Promise<FeatureFlagsResponse> {
  const res = await fetchFn(`${apiUrl}/feature-flags`, { credentials: 'include' });
  if (!res.ok) throw await toApiError(res, 'Failed to fetch feature flags');
  return res.json();
}
